import Cookies from 'js-cookie'

const TokenKey = 'Authorization';
const UserInfo = 'UserInfo';

//获取token
export function getToken() {
    return Cookies.get(TokenKey)
}

//设置token
export function setToken(token) {
    return Cookies.set(TokenKey, token)
}

//删除token
export function removeToken() {
    return Cookies.remove(TokenKey)
}

//-----------------
//设置用户信息
export function setUser(info) {
    return Cookies.set(UserInfo, info)
}

//获取用户信息
export function getUser() {
    return Cookies.getJSON(UserInfo);
}

//删除用户信息
export function removeUser() {
    return Cookies.remove(UserInfo)
}



// WEBPACK FOOTER //
// ./src/utils/setCooKies.js